import React from 'react';
import PropTypes from 'prop-types';

import {Box, Paper} from 'views/components';

import SectionHeading from '../shared/SectionHeading';
import PanelSkeleton from '../shared/skeletons/PanelSkeleton';

import MonthlyOverviewTable from './MonthlyOverviewTable';

// One card holding a single comparison table across all three periods. Previous shows
// scheduled/actual/variance (both full months, so variance is meaningful); current shows
// scheduled + a partial actual through the backend cut-off; next shows scheduled only,
// never fabricated $0 actuals.
const MonthlyFinancialOverviewSection = (props) => {
  const {
    isLoading,
    snapshot,
  } = props;

  return (
    <Box>
      <SectionHeading expression='metrics.ClientMetrics.Overview.SectionTitle' />
      {
        isLoading &&
        <PanelSkeleton height={360} />
      }
      {
        !isLoading &&
        <Paper
          sx={{
            p: 3,
            borderRadius: '12px',
            border: '1px solid #E5E5E5',
            boxShadow: 'none',
            minWidth: 0,
          }}
        >
          <MonthlyOverviewTable snapshot={snapshot} />
        </Paper>
      }
    </Box>
  );
};

MonthlyFinancialOverviewSection.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  snapshot: PropTypes.object,
};

export default React.memo(MonthlyFinancialOverviewSection);
